import { getEnvironmentConfig, getEnvVariable, getEnvVariableDefault } from '../configHelper.js';
import { Databases } from './mongoDB.databases.js';
const isLocalTestHost = () => {
    const host = getEnvVariableDefault('MONGODB_TEST_HOST', '');
    return !host || host === 'mongo' || host === '127.0.0.1' || host === 'localhost';
};
const testMongoParams = isLocalTestHost() ? 'directConnection=true' : '';
const testMongoPort = getEnvVariable('MONGODB_TEST_PORT') ?? (isLocalTestHost() ? '27017' : undefined);
const serverSelectionTimeoutMS = Number(getEnvVariableDefault('MONGODB_SERVER_SELECTION_TIMEOUT_MS', '20000'));
const definition = {
    base: {
        [Databases.content]: {
            host: getEnvVariableDefault('MONGODB_HOST', '').replace('mongodb+srv://', '').replace('mongodb://', ''),
            port: getEnvVariable('MONGODB_PORT'),
            username: getEnvVariable('MONGODB_USERNAME_CONTENT'),
            password: getEnvVariable('MONGODB_PASSWORD_CONTENT'),
            enabled: true,
            compression: true,
        },
        [Databases.system]: {
            host: getEnvVariableDefault('MONGODB_HOST', '').replace('mongodb+srv://', '').replace('mongodb://', ''),
            port: getEnvVariable('MONGODB_PORT'),
            username: getEnvVariable('MONGODB_USERNAME_SYSTEM'),
            password: getEnvVariable('MONGODB_PASSWORD_SYSTEM'),
            enabled: true,
            compression: true,
        },
        [Databases.editor]: {
            host: getEnvVariableDefault('MONGODB_HOST', '').replace('mongodb+srv://', '').replace('mongodb://', ''),
            port: getEnvVariable('MONGODB_PORT'),
            username: getEnvVariable('MONGODB_USERNAME_EDITOR'),
            password: getEnvVariable('MONGODB_PASSWORD_EDITOR'),
            enabled: true,
            compression: true,
        },
        [Databases.tracking]: {
            host: getEnvVariableDefault('MONGODB_HOST', '').replace('mongodb+srv://', '').replace('mongodb://', ''),
            port: getEnvVariable('MONGODB_PORT'),
            username: getEnvVariable('MONGODB_USERNAME_TRACKING'),
            password: getEnvVariable('MONGODB_PASSWORD_TRACKING'),
            enabled: true,
            compression: true,
        },
        databases: Object.values(Databases),
        minPoolSize: 10,
        maxPoolSize: 30,
        serverSelectionTimeoutMS,
        waitQueueTimeoutMS: 0,
    },
    local: {
        [Databases.content]: {
            host: getEnvVariableDefault('MONGODB_HOST', '127.0.0.1'),
            port: getEnvVariableDefault('MONGODB_PORT', '27017'),
            params: 'directConnection=true',
            compression: false,
        },
        [Databases.system]: {
            host: getEnvVariableDefault('MONGODB_HOST', '127.0.0.1'),
            port: getEnvVariableDefault('MONGODB_PORT', '27017'),
            params: 'directConnection=true',
            compression: false,
        },
        [Databases.editor]: {
            host: getEnvVariableDefault('MONGODB_HOST', '127.0.0.1'),
            port: getEnvVariableDefault('MONGODB_PORT', '27017'),
            params: 'directConnection=true',
            compression: false,
        },
        [Databases.tracking]: {
            host: getEnvVariableDefault('MONGODB_HOST', '127.0.0.1'),
            port: getEnvVariableDefault('MONGODB_PORT', '27017'),
            params: 'directConnection=true',
            compression: false,
        },
    },
    local_k8s: {
        [Databases.content]: {
            host: getEnvVariableDefault('MONGODB_HOST', '127.0.0.1'),
            port: getEnvVariableDefault('MONGODB_PORT', '27017'),
            params: 'directConnection=true',
            compression: false,
        },
        [Databases.system]: {
            host: getEnvVariableDefault('MONGODB_HOST', '127.0.0.1'),
            port: getEnvVariableDefault('MONGODB_PORT', '27017'),
            params: 'directConnection=true',
            compression: false,
        },
        [Databases.editor]: {
            host: getEnvVariableDefault('MONGODB_HOST', '127.0.0.1'),
            port: getEnvVariableDefault('MONGODB_PORT', '27017'),
            params: 'directConnection=true',
            compression: false,
        },
        [Databases.tracking]: {
            host: getEnvVariableDefault('MONGODB_HOST', '127.0.0.1'),
            port: getEnvVariableDefault('MONGODB_PORT', '27017'),
            params: 'directConnection=true',
            compression: false,
        },
    },
    local_e2e: {
        [Databases.content]: {
            host: getEnvVariableDefault('MONGODB_TEST_HOST', 'mongo'),
            port: testMongoPort,
            params: testMongoParams,
            compression: false,
        },
        [Databases.system]: {
            host: getEnvVariableDefault('MONGODB_TEST_HOST', 'mongo'),
            port: testMongoPort,
            params: testMongoParams,
            compression: false,
        },
        [Databases.editor]: {
            host: getEnvVariableDefault('MONGODB_TEST_HOST', 'mongo'),
            port: testMongoPort,
            params: testMongoParams,
            compression: false,
        },
        [Databases.tracking]: {
            host: getEnvVariableDefault('MONGODB_TEST_HOST', 'mongo'),
            port: testMongoPort,
            params: testMongoParams,
            compression: false,
        },
        minPoolSize: 1,
        maxPoolSize: 20,
    },
    development: {
        minPoolSize: 10,
        maxPoolSize: 15,
    },
    staging: {},
    production: {
        minPoolSize: 10,
        maxPoolSize: 80,
        waitQueueTimeoutMS: 4000,
    },
    sandbox: {
        minPoolSize: 1,
        maxPoolSize: 3,
        // Single-node / Atlas Local in k8s still runs as a replica set and may advertise pod hostnames
        // (e.g. k8s-mongodb-0) that do not resolve from other pods. Pin to the Service host:port.
        [Databases.content]: { params: 'directConnection=true' },
        [Databases.system]: { params: 'directConnection=true' },
        [Databases.editor]: { params: 'directConnection=true' },
        [Databases.tracking]: { params: 'directConnection=true' },
    },
    test: {
        [Databases.content]: {
            host: getEnvVariableDefault('MONGODB_TEST_HOST', 'mongo'),
            port: testMongoPort,
            params: testMongoParams,
            compression: false,
        },
        [Databases.system]: {
            host: getEnvVariableDefault('MONGODB_TEST_HOST', 'mongo'),
            port: testMongoPort,
            params: testMongoParams,
            compression: false,
        },
        [Databases.editor]: {
            host: getEnvVariableDefault('MONGODB_TEST_HOST', 'mongo'),
            port: testMongoPort,
            params: testMongoParams,
            compression: false,
        },
        [Databases.tracking]: {
            host: getEnvVariableDefault('MONGODB_TEST_HOST', 'mongo'),
            port: testMongoPort,
            params: testMongoParams,
            compression: false,
        },
        maxPoolSize: 80,
    },
};
// Export mongnoDBConfigTestReference for use in tests to override the config when mongodbmemoryserver is used
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const mongoDbConfigTestReference = definition.test;
export const mongoDbConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=mongoDB.config.js.map